import { graphql } from "gatsby"
import React from "react"

import HeroHighlight from "@knowit-alma/common/src/components/organisms/HeroHighlight/HeroHighlight"

const HeroHighlightBlock = ({ blockDataHeroHighlight }) => {
  const { heading, text, image, links } = blockDataHeroHighlight || {}
  const showBlock = heading && image
  return showBlock ? (
    <HeroHighlight title={heading} image={image} lead={text} links={links} />
  ) : (
    ""
  )
}

export const query = graphql`
  fragment HeroHighlight on WpBlockAcfHeroHighlight {
    __typename
    blockDataHeroHighlight {
      heading
      text
      image {
        mediaDetails {
          width
          height
        }
        sourceUrl
        altText
        altTextOriginal
      }
      links {
        link {
          url
          title
          target
        }
      }
    }
  }
`

export default HeroHighlightBlock
